<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

            <h2>{{ config_cadastro.titulo }}</h2>
            <p>{{ config_cadastro.descricao }}</p>


            <div class="form-group mt-4">
                <label for="label" class="input-label">{{ config_cadastro.label }}:</label>
                <input type="text" id="campo_texto" class="form-control" v-model="campo_texto" required :placeholder="config_cadastro.label">
            </div>
            <div style="text-align: right; width: 100%;" class="mb-5 mt-2">
                <button @click="gravar" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">done</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Gravar</label>
                </button>
            </div>

            <div class="callout col-xl-12 col-lg-12 col-md-12 mb-4">
                    <div class="card" style="border-left-color: green;">
                        <div class="card-header" data-toggle="collapse" href="#collapse2" style="color: green;">
                            <strong>{{ config_cadastro.titulo_grid }}</strong>
                        </div>
                        <div id="collapse2" class="collapse show">
                            <div class="card-body">
                                    <table class="table table-striped table-bordered mt-2 border">
                                        <thead>
                                            <tr class="text-center">
                                                <th scope="col" style="background-color: lightgrey;">Código</th>
                                                <th scope="col" style="background-color: lightgrey;">Descrição</th>
                                                <!--<th scope="col" style="background-color: lightgrey;">Situação</th>
                                                <th scope="col" style="background-color: lightgrey;">Desativar</th> -->
                                                <th scope="col" style="background-color: lightgrey;">Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="dado in config_cadastro.dados">
                                                <td style="text-align: right;">{{ dado.id }}</td>
                                                <td style="text-align: left;">{{ dado.descricao }}</td>
                                                <!--<td style="text-align: center;">{{ dado.ativo ? 'Ativo' : 'Inativo' }}</td>
                                                <td style="text-align: center;">
                                                    <button @click="ativarDesativar(dado.id, !dado.ativo)">
                                                        {{ dado.ativo ? 'Desativar' : 'Ativar' }}
                                                    </button>
                                                </td> -->
                                                <td style="text-align: center;">
                                                    <button @click="excluirItem(dado.id)" type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 150px; background-color: rgb(235, 234, 234); cursor: pointer;">
                                                        <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                                                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p>{{ config_cadastro.dados.length }} registro(s) encontrado(s).</p>
                            </div>
                        </div>
                    </div>
                </div>
    </div>
  </template>
  
<script>
  import axios from 'axios';
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            campo_texto: '',
            tela: '',
            tabela: '',
        };
        
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        config_cadastro: {
            type: Object,
            required: true
        }
    },
    methods: {
        gravar() {

            const dados_gravar = {
                campo_texto: this.campo_texto,
                tela: this.config_cadastro.tela,
                tabela: this.config_cadastro.tabela,
            };

            axios.post(this.BASE_URL + 'cadastro/' + this.config_cadastro.tela, dados_gravar)
                .then(response => {
                    if (response.status === 200) {
                        alert('Dados gravados com sucesso!');
                        window.location.reload();
                    } else {
                        alert('Erro ao gravar dados.');
                    }
                })
                .catch(error => {
                    alert('Erro ao gravar dados: ' + error);
                    console.error(error);
                });
        },
        ativarDesativar(id, ativo) {
            //Rotina não desenvolvida
        },
        excluirItem(id) {
            const dados_remover = {
                id: id,
            };

            axios.post(this.BASE_URL + 'cadastro/' + this.config_cadastro.tela + "/remover", dados_remover)
                .then(response => {
                    if (response.status === 200) {
                        alert('Registro deletado com sucesso!');
                        window.location.reload();
                    } else {
                        alert('Erro ao deletar registro.');
                    }
                })
                .catch(error => {
                    alert('Erro ao deletar registro: ' + error);
                    console.error(error);
                });

        },


    },
    
};
</script>
  
  <style scoped>

  </style>
  